export default {
  /**
   * Set the list.
   *
   * @param state
   * @param items
   */
  setTeacherAwayIndividualEntitlementList(state, items) {
    console.log("Set items", items);
    state.items = items;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setTeacherAwayIndividualEntitlementListPagination(state, pagination) {
    console.log("Pagination ", pagination);
    state.pagination = pagination;
  },

  /**
   * Set Teacher individual entitlement form.
   *
   * @param state
   * @param form
   */
  setTeacherAwayIndividualEntitlementForm(state, form) {
    console.log("Form ", form);
    state.form = form;
    state.form.employee_id = form.teacher_id;
  },

  /**
   * Set the list.
   *
   * @param state
   * @param items
   */
  setStaffAwayIndividualEntitlementList(state, items) {
    console.log("Set items", items);
    state.items = items;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setStaffAwayIndividualEntitlementListPagination(state, pagination) {
    console.log("Pagination ", pagination);
    state.pagination = pagination;
  },

  /**
   *
   * @param state
   * @param page
   */
  setStaffAwayIndividualEntitlementListPage(state, page) {
    console.log("Pagination ", page);
    state.pagination.current_page = page;
  },

  /**
   * Set Staff individual entitlement form.
   *
   * @param state
   * @param form
   */
  setStaffAwayIndividualEntitlementForm(state, form) {
    console.log("Form ", form);
    state.form = form;
    state.form.employee_id = form.staff_id;
  },
};
